import React from 'react';
import RouteCostAnalysis from '../../components/analytics/RouteCostAnalysis';
import { PageLayout } from '../../ui';

const CostAnalyticsPage: React.FC = () => {
  return (
    <PageLayout
      title="Анализ стоимости маршрутов"
      subtitle="Реальные перевозки и расчёты из калькулятора доставки"
    >
      <RouteCostAnalysis />
    </PageLayout>
  );
};

export default CostAnalyticsPage;
